const LangNotFound = {
	"notFound._title": ["Doh 404!", "Doh 404!"],
	"notFound._message": [
		`These are <em>not</em> the droids you are looking for!`,
		`Đang có sự cố xảy ra!`,
	],
}

export default LangNotFound
